export default "__VITE_ASSET__Dln6GmRY__"